import {ref, watch} from '@vue/composition-api'

const useMessage = () => {
    const message = ref('');
    const emptyMessage = ref(false)
    const errorMessage = ref(null)

    watch(message, (message) => {
        emptyMessage.value = !message
    })

    const validateMessage = () => {
        if (!message.value) {
            emptyMessage.value = true;
        }

        errorMessage.value = message.value.length > 1200 ? 
            'You have reached your maximum limit of characters allowed (1200 symbols)' : null
    }

    return {
        message,
        emptyMessage,
        errorMessage,
        validateMessage
    }
}

export default useMessage